import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const constantContact = defineConnector({
  identifier: "constantContact",
  name: "Constant Contact",
  tagLine: "Email marketing",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://api\\.cc\\.email/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Create a Constant Contact app",
      items: [
        {
          kind: "markdown",
          content:
            "Go to the [Constant Contact Developer Portal](https://developer.constantcontact.com/) and navigate to **My Applications** to create a new application and get your API key and secret.",
        },
      ],
    },
    {
      title: "Configure the redirect URI",
      items: [
        {
          kind: "markdown",
          content: "In your app’s settings, add the following redirect URI:",
        },
        {
          kind: "copyable",
          label: "Redirect URI",
          value: "{API_URL}/connected-apps/oauth/constantContact/callback",
        },
      ],
    },
    {
      title: "Enter your app credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          placeholder: "Paste your Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          placeholder: "Paste your Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
    {
      title: "Configure scopes",
      items: [
        {
          kind: "input",
          label: "Scopes",
          placeholder: "offline_access",
          helperText: "Space-separated list of permission scopes.",
          target: { kind: "oauthConnection", field: "scopes" },
        },
      ],
    },
    {
      title: "Authorize your Constant Contact account",
      items: [
        {
          kind: "markdown",
          content: "Click below to authorize your Constant Contact account.",
        },
        {
          kind: "oauth",
          dependsOn: [
            { kind: "oauthConnection", field: "clientId" },
            { kind: "oauthConnection", field: "clientSecret" },
          ],
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "authorization_code",
    authorizationEndpoint: () =>
      "https://authz.constantcontact.com/oauth2/default/v1/authorize",
    tokenEndpoint: () =>
      "https://authz.constantcontact.com/oauth2/default/v1/token",
    tokenEndpointAuthMethod: () => "client_secret_post",
    clientCredentialsFrom: "db",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: () => "https://api.cc.email/v3/account/summary",
  },
});
